// extracted by mini-css-extract-plugin
export default {"wrapper":"CalendarPage_wrapper__q5w5q","row":"CalendarPage_row__rg3Wi"};